import { useState, Dispatch, SetStateAction } from 'react';
import tw, { styled } from 'twin.macro';
import { UserGroupIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'next-i18next';
import { useAtom } from 'jotai';

import CandidateInterviewDateTime, { InterviewScheduleSteps } from './candidate-interview-datetime';
import { CandidateModalStatusChangeScreen } from './discard-candidate/candidate-state-change-confirmation';
import { selectedJobApplicationAtom } from '../../../employer-job-listing.atoms';

function CandidateInterview({ firstName, jobPositionId, workerId }: CandidateInterviewProps) {
  const [interviewScheduleStep, setInterviewScheduleStep] = useState(InterviewScheduleSteps.ACTION_CONFIRMATION);

  return (
    <MainWrapper>
      <InnerWrapper>
        {interviewScheduleStep === InterviewScheduleSteps.ACTION_CONFIRMATION ? (
          <CandidateInterviewActionConfirmation setStep={setInterviewScheduleStep} />
        ) : interviewScheduleStep === InterviewScheduleSteps.VIEW_SUCCESS_MESSAGE ? (
          <CandidateInterviewActionConfirmation isCompleted />
        ) : (
          <CandidateInterviewDateTime
            firstName={firstName}
            setStep={setInterviewScheduleStep}
            step={interviewScheduleStep}
            jobPositionId={jobPositionId}
            workerId={workerId}
          />
        )}
      </InnerWrapper>
    </MainWrapper>
  );
}
export default CandidateInterview;

const MainWrapper = styled.div`
  ${tw`w-full h-full`}
`;
const InnerWrapper = styled.div`
  ${tw`mx-auto flex flex-col justify-between  text-center h-full`}
`;

interface CandidateInterviewProps {
  firstName: string;
  jobPositionId: string;
  workerId: string;
  onClose: () => void;
}

function CandidateInterviewActionConfirmation({
  setStep,
  isCompleted,
}: {
  isCompleted?: boolean;
  setStep?: Dispatch<SetStateAction<InterviewScheduleSteps>>;
}) {
  const { t } = useTranslation('job-positions-page');
  const [selectedJobApplication] = useAtom(selectedJobApplicationAtom);
  const candidateName = selectedJobApplication?.worker?.name ?? '';

  return (
    <CandidateModalStatusChangeScreen
      topIcon={<UserGroupIcon tw="h-6 w-6 text-neutral-700" />}
      defaultText={`${t('you_are_moving_name_in_candidates_to_be_interviewed', { name: candidateName })}.`}
      successText={t('you_moved_name_in_candidates_to_be_interviewed', { name: candidateName })}
      handleSubmit={() => {
        setStep && setStep(InterviewScheduleSteps.SELECT_DATE_TIME);
      }}
      subtext={isCompleted ? t('we_will_send_you_both_a_reminder_the_day_before_the_interview') : ''}
      isCompletedSuccessfully={isCompleted}
    />
  );
}
